export default __webpack_public_path__ + "static/media/fassaden3.8e19a97b.jpg";